export const roundUp = (value: number, precision: number): number => {
    const result = Math.round(value / precision) * precision
    return result || roundUp(value, precision / 10)
}
